// ============================================================================
// RYAN TWOMEY MERCH THEME - JAVASCRIPT
// ============================================================================

// MOBILE MENU TOGGLE
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');

  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('active');
    });
  }

  // Close menu when link is clicked
  const navLinks = document.querySelectorAll('.header__nav-link');
  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      if (nav) {
        nav.classList.remove('active');
      }
    });
  });
});

// CART FUNCTIONALITY
class Cart {
  constructor() {
    this.cartItems = [];
    this.loadCart();
  }

  async loadCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.cartItems = cart.items || [];
      this.updateCartUI();
    } catch (error) {
      console.error('Error loading cart:', error);
    }
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        })
      });

      if (response.ok) {
        const result = await response.json();
        this.showNotification('Item added to cart!', 'success');
        await this.loadCart();
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showNotification('Error adding to cart', 'error');
    }
  }

  async updateQuantity(variantId, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.loadCart();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      this.showNotification('Error updating cart', 'error');
    }
  }

  async removeFromCart(variantId) {
    await this.updateQuantity(variantId, 0);
  }

  updateCartUI() {
    const cartCount = this.cartItems.reduce((total, item) => total + item.quantity, 0);
    const cartIcon = document.querySelector('.header__cart');

    if (cartIcon) {
      cartIcon.setAttribute('data-count', cartCount);
    }
  }

  showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;

    const container = document.querySelector('.content-wrapper') || document.body;
    container.insertBefore(notification, container.firstChild);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  }
}

// Initialize cart on page load
const cart = new Cart();

// PRODUCT PAGE FUNCTIONALITY
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.querySelector('.product-page__button');

  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      const variantSelect = document.querySelector('[name="id"]');
      const quantityInput = document.querySelector('.quantity-input input');

      if (variantSelect && quantityInput) {
        const variantId = variantSelect.value;
        const quantity = parseInt(quantityInput.value) || 1;

        if (variantId) {
          cart.addToCart(variantId, quantity);
        }
      }
    });
  }

  // QUANTITY ADJUSTMENT
  const quantityMinusButton = document.querySelector('[data-action="decrease"]');
  const quantityPlusButton = document.querySelector('[data-action="increase"]');
  const quantityInput = document.querySelector('.quantity-input input');

  if (quantityMinusButton && quantityInput) {
    quantityMinusButton.addEventListener('click', function() {
      let quantity = parseInt(quantityInput.value) || 1;
      if (quantity > 1) {
        quantityInput.value = quantity - 1;
      }
    });
  }

  if (quantityPlusButton && quantityInput) {
    quantityPlusButton.addEventListener('click', function() {
      let quantity = parseInt(quantityInput.value) || 1;
      quantityInput.value = quantity + 1;
    });
  }

  // CART PAGE FUNCTIONALITY
  const cartRemoveButtons = document.querySelectorAll('.cart-item__remove-button');
  cartRemoveButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');
      if (variantId) {
        cart.removeFromCart(variantId);
      }
    });
  });

  const quantityAdjustButtons = document.querySelectorAll('.cart-item__quantity-button');
  quantityAdjustButtons.forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const action = this.getAttribute('data-action');
      const quantitySpan = this.parentElement.querySelector('span');

      if (quantitySpan && variantId) {
        let quantity = parseInt(quantitySpan.textContent) || 1;

        if (action === 'increase') {
          quantity++;
        } else if (action === 'decrease' && quantity > 1) {
          quantity--;
        }

        cart.updateQuantity(variantId, quantity);
      }
    });
  });
});

// REGISTER MARK POSITIONING
document.addEventListener('DOMContentLoaded', function() {
  const marks = document.querySelectorAll('.registration-mark');
  // Marks are positioned via CSS, this is a placeholder for future enhancements
});

// SMOOTH SCROLLING (without triggering layout issues)
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

// IMAGE LAZY LOADING
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        observer.unobserve(img);
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}
